/**
 * Static geographic reference markers for Hoàng Sa & Trường Sa.
 * UI overlay only — never sourced from backend.
 * Coordinates are [longitude, latitude].
 */
export interface VietnamIslandMarkerDef {
  id: string;
  displayName: string;
  longitude: number;
  latitude: number;
}

export const VIETNAM_ISLAND_MARKERS: readonly VietnamIslandMarkerDef[] = [
  {
    id: 'hoang-sa',
    displayName: 'Hoàng Sa (Việt Nam)',
    longitude: 112.25,
    latitude: 16.5,
  },
  {
    id: 'truong-sa',
    displayName: 'Trường Sa (Việt Nam)',
    longitude: 114.2,
    latitude: 10.2,
  },
] as const;
